import axios from 'axios';
import store from '../redux/store/store';
const API_NOTIFICATION_URL = import.meta.env.VITE_API_URL;

const notificationService = {



    fetchNotification: async (userId) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.get('/Notification', {
                params: {
                    UserId: userId,
                }
                , headers: { Authorization: `Bearer ${userToken}` }
            });

            return response.data.data;
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },
    //tek mesaj için okundu 
    readedNotification: async (data) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
    

            const requestBody = {
                UserId: data.userId,
                Id: data.id
            };

            const response = await axios.put('/Notification', requestBody, {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data.data;
        } catch (error) {
            console.error('Error updating notifications:', error);
            throw error;
        }
    },
    //tümünü okundu yap
    readedAllNotification: async (userId) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
        

            const requestBody = {
                UserId: userId,
            };

            const response = await axios.put('/Notification/UpdateRange', requestBody, {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data.data;
        } catch (error) {
            console.error('Error updating notifications:', error);
            throw error;
        }
    },
    //tüm bildirimleri çeker
    fetchAllNotification: async (userId, page) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.get('/Notification', {
                params: {
                    UserId: userId,
                    Page: page,
                    Pagination: true
                }
                , headers: { Authorization: `Bearer ${userToken}` }
            });

            return response.data.data;
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },

}
export default notificationService;
